/*
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import TWEEN from '@tweenjs/tween.js';

const EPSILON = 0.00001;

export default class Scaleable extends THREE.Object3D {
  constructor(props) {
    super(props);
    this._scale = { value: EPSILON };
    this.scaleTween = new TWEEN.Tween(this._scale);
    this.scaleTween.easing(TWEEN.Easing.Cubic.InOut);
    this.scaleTween.onUpdate(tween => {
      let value = this._scale.value;
      this.scale.set(value, value, value);
      this.updateMatrixWorld(true);
      this.onUpdate(tween);
    });
    this.setScale(EPSILON);
  }

  onUpdate = tween => {};

  scaleIn = (duration, delay, cb) => {
    this.fadeInCb = cb;
    this.scaleTween.stop();
    this.scaleTween.to({ value: 1.0 }, duration != undefined ? duration : 333);
    this.scaleTween.delay(delay != undefined ? delay : 0);
    this.scaleTween.start();
    this.scaleTween.onComplete(() => {
      if (this.fadeInCb != undefined) {
        this.fadeInCb();
      }
    });
    this.visible = true;
    return this.scaleTween;
  };

  scaleOut = (duration, delay, cb) => {
    this.fadeOutCb = cb;
    this.scaleTween.stop();
    this.scaleTween.to(
      { value: EPSILON },
      duration != undefined ? duration : 333
    );
    this.scaleTween.delay(delay != undefined ? delay : 0);
    this.scaleTween.onComplete(() => {
      if (this.fadeOutCb != undefined) {
        this.fadeOutCb();
      }
      this.visible = false;
    });
    if (duration === 0) {
      this.visible = false;
      this.setScale(0.00001);
    }
    this.scaleTween.start();
    return this.scaleTween;
  };

  setScale = value => {
    this._scale.value = value;
    this.scale.set(value, value, value);
    this.updateMatrixWorld(true);
  };

  getScale = () => {
    return this._scale.value;
  };
}



// WEBPACK FOOTER //
// ./src/gfx/Scaleable.js